export const LOCATION_MAIN = '/'
export const LOCATION_CHAT = '/chat'

export const LOCATION_MARKET_SREDNOY = '/srednoy'
export const LOCATION_MARKET_CENTRAL_PODOLSK = '/central_podolsk'
export const LOCATION_MARKET_CENTRAL_YAROSLAVL = '/central_yaroslavl'

